import React from "react";
import "./StorySection.scss";

const StorySection = () => {
  return (
    <section className="story-section">
      <div className="story-section__container">
        <div className="story-section__content">
          <div className="story-section__header">
            <p className="story-section__subtitle">Our story</p>

            <h2 className="story-section__title">
              Handshake infographic mass market crowdfunding iteration.
            </h2>
          </div>

          <p className="story-section__description">
            Conversion angel investor entrepreneur first mover advantage.
            Handshake infographic mass market crowdfunding iteration. Traction
            stock user experience deployment beta innovator incubator focus.
            Sales user experience branding growth hacking holy grail
            monetization conversion prototype stock network effects. Learning
            curve network effects return on investment bootstrapping
            business-to-consumer.
          </p>
        </div>
      </div>
    </section>
  );
};

export default StorySection;
